(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class HeroCarousel {
      constructor(root) {
        this.root = root;
        this.wrapper = root.querySelector('[data-testid="hero-media-wrapper"]');
        this.controls = root.querySelector('[data-hero-carousel-controls]');
        if (!this.wrapper || !this.controls) return;

        this.slides = Array.from(this.wrapper.querySelectorAll('[data-hero-slide]'));
        if (this.slides.length < 2) return;

        this.dotsContainer = root.querySelector('[data-hero-carousel-dots]');
        this.prevBtn = root.querySelector('[data-hero-carousel-prev]');
        this.nextBtn = root.querySelector('[data-hero-carousel-next]');
        this.autoplay = root.dataset.carouselAutoplay === 'true';
        this.autoplaySpeed = parseInt(root.dataset.carouselSpeed, 10) || 5000;
        this.timer = null;

        this.bindEvents();
        this.buildDots();
        this.observeSlides();
        if (this.autoplay) this.startAutoplay();
      }

      visibleSlides() {
        return this.slides.filter((slide) => slide.offsetParent !== null);
      }

      buildDots() {
        if (!this.dotsContainer) return;
        const visible = this.visibleSlides();
        this.dotsContainer.innerHTML = '';
        visible.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hero__carousel-dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          dot.addEventListener('click', () => this.scrollToSlide(slide));
          this.dotsContainer.appendChild(dot);
        });
        this.dots = Array.from(this.dotsContainer.children);
        this.setActiveDot(visible[0]);
      }

      scrollToSlide(slide) {
        this.wrapper.scrollTo({ left: slide.offsetLeft, top: slide.offsetTop, behavior: 'smooth' });
      }

      setActiveDot(activeSlide) {
        if (!this.dots || !activeSlide) return;
        const visible = this.visibleSlides();
        const index = visible.indexOf(activeSlide);
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      observeSlides() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.setActiveDot(entry.target);
              }
            });
          },
          { root: this.wrapper, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      bindEvents() {
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
        this.wrapper.addEventListener('mouseenter', () => this.stopAutoplay());
        this.wrapper.addEventListener('mouseleave', () => {
          if (this.autoplay) this.startAutoplay();
        });
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => this.buildDots(), 150);
        });
      }

      step(direction) {
        const visible = this.visibleSlides();
        if (!visible.length) return;
        const scrollLeft = this.wrapper.scrollLeft;
        let current = visible.findIndex((slide) => Math.abs(slide.offsetLeft - scrollLeft) < 5);
        if (current === -1) current = 0;
        const next = (current + direction + visible.length) % visible.length;
        this.scrollToSlide(visible[next]);
      }

      startAutoplay() {
        this.stopAutoplay();
        this.timer = setInterval(() => this.step(1), this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.timer) clearInterval(this.timer);
      }
    }

    function initHeroCarousels(scope) {
      (scope || document).querySelectorAll('.hero--carousel').forEach((root) => {
        if (root.dataset.heroCarouselInit) return;
        root.dataset.heroCarouselInit = 'true';
        new HeroCarousel(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initHeroCarousels());
    } else {
      initHeroCarousels();
    }

    // Theme editor swaps section HTML via AJAX on every settings change -
    // re-run init so new/updated markup gets its listeners.
    document.addEventListener('shopify:section:load', (event) => initHeroCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
